import { userinfo } from './../../../Services/userinfo';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { BeneficiaryDetails_DH } from '../../../Models/BeneficiaryDetails_DH';
import { ClaimsHistory_DH } from '../../../Models/ClaimsHistory_DH';
import { mdlProposalSaveReq } from '../../../Models/mdlProposalSaveReq';
import { DHcovers } from '../../../Models/DHcovers';
import { TranslateService } from '@ngx-translate/core';
import { restURL } from '../../../Models/restURL';
import { userService } from '../../../Services/userService';
import { PayfortTransInfoModel } from '../../../Models/ProposalModel';
import { motorProposalService } from '../../../Services/motorProposalService';

@Component({
  selector: 'DomesticPremiumInfo',
  templateUrl: './DomesticPremiumInfo.html',
  styleUrls: ['./DomesticPremiumInfo.css']
})
export class DomesticPremiumInfo {

  public isSubmitted: boolean = false;
  public objProposal: mdlProposalSaveReq = new mdlProposalSaveReq();
  public objClaims: ClaimsHistory_DH = new ClaimsHistory_DH();
  public ObjBeneficiaryList: BeneficiaryDetails_DH = new BeneficiaryDetails_DH();
  public transObj: PayfortTransInfoModel = new PayfortTransInfoModel();
  @ViewChild('txtIBAN2') txtIBAN2Element: ElementRef;
  @ViewChild('txtIBAN3') txtIBAN3Element: ElementRef;
  @ViewChild('txtIBAN4') txtIBAN4Element: ElementRef;
  @ViewChild('txtIBAN5') txtIBAN5Element: ElementRef;
  @ViewChild('txtIBAN6') txtIBAN6Element: ElementRef;
  public MandatoryCover1: number;
  public MandatoryCover2: number;
  public MandatoryCover3: number;
  public MandatoryCover4: number;

  public ShowProposalDeclined: boolean = false;
  public ShowAddClaimBtn: boolean = false;
  public modal: boolean = false;
  public modal1: boolean = false;
  public ShowAddBeneficiary: boolean = false;
  public ClaimsinLastFiveYears: boolean = false;
  public modal2: boolean = false;
  public showLoading: boolean = false;
  public Lng: string;

  constructor(private EncriptService: motorProposalService, private userinfo: userService, private url: restURL, public Translate: TranslateService, private router: Router, private http: HttpClient) {

    if (sessionStorage.getItem("Language") != null) { this.Lng = sessionStorage.getItem("Language"); }
    else { this.Lng = "en"; }
    this.objProposal = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("DomesticProposal")));

    if (this.objProposal.SelectedCovers == null) {
    
      this.objProposal.SelectedCovers = new Array<DHcovers>();
      this.MandatoryCover1 = 3000;
      this.AddCovers("501801", 3000);
      this.MandatoryCover2 = 3000;
      this.AddCovers("501802", 3000);
      this.MandatoryCover3 = 3000;
      this.AddCovers("501803", 3000);
      this.MandatoryCover4 = 3000;
      this.AddCovers("501804", 3000);
    }
    else {
      this.MandatoryCover1 = this.objProposal.SelectedCovers.filter(t => t.CoverCode == "501801")[0].SumInsured;
      this.MandatoryCover2 = this.objProposal.SelectedCovers.filter(t => t.CoverCode == "501802")[0].SumInsured;
      this.MandatoryCover3 = this.objProposal.SelectedCovers.filter(t => t.CoverCode == "501803")[0].SumInsured;
      this.MandatoryCover4 = this.objProposal.SelectedCovers.filter(t => t.CoverCode == "501804")[0].SumInsured;
    
    }
    if (this.objProposal.ClaimsHistory == null) { this.objProposal.ClaimsHistory = new Array<ClaimsHistory_DH>(); }
    if (this.objProposal.BeneficiaryDetails == null) { this.objProposal.BeneficiaryDetails = new Array<BeneficiaryDetails_DH>(); }
   
  }


  Prev() {
    sessionStorage.setItem("DomesticProposal", this.EncriptService.EncriptObject(JSON.stringify(this.objProposal)));
    this.router.navigate(['NewDashboard/DomesticInsuredInfo']);
  }

  CheckProposalDeclined(event, value) {

    if (value == true) {
      this.ShowProposalDeclined = true;
    } else {
      this.ShowProposalDeclined = false;
    }
  }

  AddClaimDetails(event, value) {
   
    if (value == true) {
      this.ShowAddClaimBtn = true;
    } else {
      this.objProposal.ClaimsHistory = null
      this.ShowAddClaimBtn = false;
    }
  }

  ShowClaimModal() {
    this.modal = true;
  }

  closemodal() {
    this.modal = false;
  }

  AddClaim(valid) {
    if (!valid) {
      Swal(this.Translate.instant("Please fill all fields."))
      return;
    }
    let newclaim: ClaimsHistory_DH = new ClaimsHistory_DH();
    newclaim.Amount = this.objClaims.Amount;
    newclaim.Details = this.objClaims.Details;
    newclaim.ClaimYear = this.objClaims.ClaimYear;
    if (this.objProposal.ClaimsHistory == null) { this.objProposal.ClaimsHistory = new Array<ClaimsHistory_DH>(); }
    if (this.objProposal.ClaimsHistory.length > 4) { Swal(this.Translate.instant("You Can Provide Maximum 5 Claim Details")); this.objClaims = new ClaimsHistory_DH(); return; }
    let ChkDuplicates: boolean = false;
    for (var i = 0; i < this.objProposal.ClaimsHistory.length; i++) {
      if (this.objProposal.ClaimsHistory[i].Amount == newclaim.Amount && this.objProposal.ClaimsHistory[i].ClaimYear == newclaim.ClaimYear && this.objProposal.ClaimsHistory[i].Details == newclaim.Details)
        ChkDuplicates = true;
    }
    if (ChkDuplicates == false) { this.objProposal.ClaimsHistory.push(newclaim) }
    this.modal = false;
    this.objClaims = new ClaimsHistory_DH();
  }


  checkIfArrayIsUnique(myArray): boolean {
    for (var i = 0; i < myArray.length; i++) {
      for (var j = 0; j < myArray.length; j++) {
        if (i != j) {
          if (myArray[i] = myArray[j]) {
            return true;
          }
        }
      }
    }
    return false;
  }

  AddBeneficiary(valid) {
    if (!valid) {
      Swal(this.Translate.instant("Please fill all fields."))
      return;
    }
    if(this.objProposal.BeneficiaryDetails!=null){if(this.objProposal.BeneficiaryDetails.length>4){Swal(this.Translate.instant("You Can Maximum 5 Beneficiaries")); return;}}
    let NewBeneficiary: BeneficiaryDetails_DH = new BeneficiaryDetails_DH();
    NewBeneficiary.Name = this.ObjBeneficiaryList.Name;
    NewBeneficiary.Relationship = this.ObjBeneficiaryList.Relationship;
    NewBeneficiary.ContactNo = this.ObjBeneficiaryList.ContactNo;
    NewBeneficiary.EMail = this.ObjBeneficiaryList.EMail;
    NewBeneficiary.BeneficiaryAddress = this.ObjBeneficiaryList.BeneficiaryAddress;
    this.objProposal.BeneficiaryDetails.push(NewBeneficiary);
    this.ObjBeneficiaryList = new BeneficiaryDetails_DH();
    
    this.modal1 = false;
  }

  removeBeneficiary(index) {
    this.objProposal.BeneficiaryDetails.splice(index, 1);
  }

  ShowBeneficiaryModal() {
    this.modal1 = true;
  }

  ViewBeneficiaryModal() {
    if (this.objProposal.BeneficiaryDetails.length == 0) {
      Swal(this.Translate.instant("No Beneficiary Details Foud Please Click on AddBeneficiary To Add"))
      return;
    }
    this.modal2 = true;
  }

  closemodal1() {
    this.modal1 = false;
  }

  closemodal2() {
    this.modal2 = false;
  }

  iban1Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 2) {
        setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
      }
    }
  }
  iban2Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        let bankCode: number = Number(event.substring(0, 2))

        if (this.objProposal.bankList.filter(t => t.BankCode == bankCode.toString()).length > 0) {
          this.objProposal.BankCode = bankCode;
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          this.objProposal.Bankname = "";
          this.objProposal.BankCode = 0;
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);

        }
      }
    }
  }
  iban3Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN4Element.nativeElement.focus(), 0);
      }
    }
  }
  iban4Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN5Element.nativeElement.focus(), 0);
      }
    }
  }
  iban5Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN6Element.nativeElement.focus(), 0);
      }
    }
  }

  //<<<<<<<<<<Add Covers Start>>>>>>>>>
  AddCovers(ValCoverCode, SumInsured) {
    let index: number;
    index = this.objProposal.SelectedCovers.findIndex(t => t.CoverCode == ValCoverCode);
    if (index >= 0)
      this.objProposal.SelectedCovers.splice(index, 1);
    if (SumInsured > 0) {
      let objCover: DHcovers = new DHcovers();
      objCover.CoverCode = ValCoverCode;
      objCover.SumInsured = SumInsured;
      this.objProposal.SelectedCovers.push(objCover)
     
    }
    if (ValCoverCode == "501808" || ValCoverCode == "501809") {

      if (SumInsured > 0) { this.modal1 = true; this.ShowAddBeneficiary = true; } else { this.modal1 = false; this.ShowAddBeneficiary = false; }
    }
  }
  //<<<<<<<<<<Add Covers End>>>>>>>>>
  ValidateYear(Val) {
    if (Val < 2000) {
      Swal(this.Translate.instant("Year Must be greater Than 2000"))
      this.objClaims.ClaimYear = null
    }
  }

  SaveProposal() {
    if (this.objProposal.SelectedCovers.length == 0) {
      Swal(this.Translate.instant("Please Select Coverages"));
      return;
    }

    let BenficieryCoverCheck: boolean = false;
    for (var i = 0; i < this.objProposal.SelectedCovers.length; i++) {
      if (this.objProposal.SelectedCovers[i].CoverCode == "501808" || this.objProposal.SelectedCovers[i].CoverCode == "501809")
        BenficieryCoverCheck = true;
    }
    if (BenficieryCoverCheck == true && this.objProposal.BeneficiaryDetails.length == 0) {
      Swal(this.Translate.instant("Please Add Benificiery Details"));
      return;
    }
    if (this.ClaimsinLastFiveYears == true && this.objProposal.ClaimsHistory.length == 0) {
      Swal(this.Translate.instant("Please Add Claim Details"));
      return;
    }

    if (this.objProposal.IBAN1 != null && this.objProposal.IBAN2 != null && this.objProposal.IBAN3 != null && this.objProposal.IBAN4 != null && this.objProposal.IBAN5 != null && this.objProposal.IBAN6 != null) {
      this.objProposal.IBANNo = this.objProposal.IBAN1 + this.objProposal.IBAN2 + this.objProposal.IBAN3 + this.objProposal.IBAN4 + this.objProposal.IBAN5 + this.objProposal.IBAN6;
    }
    else { Swal(this.Translate.instant("Invalid Iban No")); return; }

    if (this.objProposal.IBANNo.length != 24) {
      Swal(this.Translate.instant("IBAN Number must be 24 digits")); return;
    }
    if ((this.objProposal.BankCode == 0 || this.objProposal.BankCode == null)) {
      Swal(this.Translate.instant("Invalid Bank Name")); return;}


    this.http.post<PayfortTransInfoModel>(this.url.baseURL + "/DomesticHelper/PremiumCalAndProposalAdd", this.objProposal, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.showLoading = false;
        this.transObj = result;


        if (this.transObj.st.StatusCode === "S") {
          let stHTML: string = '<p style="color:green;font-size: 15px;"><b>' + this.Translate.instant("Proposal Submitted Successfully") + '</b></p> </b>' +
            '<p style="color:#20559e;font-size: 15px;"><b>' + this.Translate.instant("Proposal No :") + '<span style="color:maroon;">' + result.ProposalNo + '</span></b></p> </b>' +
            '<p style="color:#20559e;font-size: 15px;"><b>' + this.Translate.instant("Total Premium :") + '<span style="color:maroon;">' + result.Premium + '</span></b></p>'
          Swal({
            //imageUrl: '..\assets\img\AcigLogo.jpg',
            //title:this.Translate.instant("Proposal Info"),
            html: stHTML,
            //type: "info",
            background: 'white',
          });
          sessionStorage.setItem("NavFrom", "PR");
          //sessionStorage.setItem("transObj", JSON.stringify(this.transObj));
          sessionStorage.removeItem("DomesticProposal");
          sessionStorage.setItem("transObj", this.EncriptService.EncriptObject(JSON.stringify(this.transObj)));
          sessionStorage.setItem("CurrentRoute", "PayfortPayment");
          this.router.navigate(['/NewDashboard/PayfortPayment']);
        }
        else { Swal(this.Translate.instant(this.transObj.st.StatusDesc)); }


      },
        (error) => {
          this.showLoading = false;
          Swal(this.Translate.instant(error));
        });

  }



}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/DomesticHelperPortal/DomesticPremiumInfo/DomesticPremiumInfo.ts